var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGfanz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 46,
    viewBox: "0 0 115 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_553_9742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.9454 23.8304H53.9197V21.8648H59.428V28.8534C57.9539 29.5086 56.2471 29.8726 53.9973 29.8726C49.3424 29.8726 46.084 26.9607 46.084 22.7384C46.084 18.5161 49.4976 15.677 53.9197 15.677C56.1695 15.677 58.2642 16.3322 59.428 17.3514L57.6436 19.1713C56.9454 18.4433 55.4713 17.7881 53.9973 17.7881C50.9716 17.7881 48.9545 19.9721 48.9545 22.7384C48.9545 25.5047 50.894 27.7614 54.0749 27.7614C55.161 27.7614 56.092 27.6158 56.9454 27.2518V23.8304Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4713 23.8304V29.5086H61.9111V16.041H71.2209V18.0794H64.4713V21.792H70.833V23.8304H64.4713Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0892 29.5099L81.7703 26.4524H75.4863L74.1674 29.5099H71.2969L77.581 15.9695H79.8308L86.0373 29.5099H83.0892ZM78.5895 18.8814L76.3397 24.4141H80.8394L78.5895 18.8814Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4444 29.5086L90.6172 19.0985H90.5397V29.5086H87.9795V16.041H91.3931L98.1426 26.1599V16.041H100.703V29.5086H97.4444Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.652 29.5086V27.3247L111.488 18.0794H103.73V16.041H114.514V18.1522L106.6 27.3975H114.669V29.5086H103.652Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9292 33.5136C29.8688 30.8929 30.9549 27.1074 30.9549 22.8123C30.9549 18.5173 29.9463 14.659 27.9292 12.0383C26.5328 10.2183 24.826 9.05356 22.6537 8.54398C23.895 8.17999 25.2139 7.96159 26.7655 7.96159C35.9201 7.96159 39.4112 15.6054 39.4112 22.8123C39.4112 30.0193 35.9201 37.6631 26.7655 37.6631C25.2139 37.6631 23.895 37.4447 22.6537 37.0807C24.826 36.4983 26.6103 35.3336 27.9292 33.5136ZM26.7655 43.3413C20.8693 43.3413 15.9817 41.0846 12.6457 36.9351C9.77523 33.2952 8.22361 28.4178 8.22361 22.8123C8.22361 17.2069 9.77523 12.3295 12.6457 8.68957C15.9817 4.4673 20.8693 2.28337 26.7655 2.28337C27.3862 2.28337 28.0844 2.28337 28.705 2.35616C26.0673 1.0458 22.964 0.390625 19.7056 0.390625C13.344 0.390625 8.14602 2.86575 4.57729 7.52481C1.55162 11.4559 0 16.7701 0 22.8123C0 28.8546 1.6292 34.096 4.57729 38.0999C8.14602 42.7589 13.344 45.2341 19.7056 45.2341C22.964 45.2341 26.0673 44.5789 28.705 43.2685C28.0068 43.3413 27.3862 43.3413 26.7655 43.3413Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_553_9742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGfanz);
export default __webpack_public_path__ + "static/media/GFANZ.1cf06c5611e0f813f51a8cf70d95395d.svg";
export { ForwardRef as ReactComponent };